const colors = {
	tprimary: '#514538',
	tsecondary: '#FAFAE3',
	ttertiary: '#b08267',
	snooker: '#0a6c03',
};

export default colors;
